import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { MinimumWageConfigurationModel } from '@/app/models/configuration/minimumWageConfigurationModel';
import { toast } from "@/lib/toasts/api";
import { useLocalize } from "@/modules/shared/context/localize/LocalizeContext";

// Toaster renderuje `text` dosłownie - klucze trzeba przetłumaczyć TUTAJ, inaczej
// użytkownik widzi na ekranie "configuration.save-error".
const serverMessage = (error: unknown): string | undefined => {
  const data = (error as { response?: { data?: unknown } })?.response?.data
  if (typeof data === 'string') return data || undefined
  const message = (data as { message?: unknown })?.message
  return typeof message === 'string' && message.trim() ? message : undefined
}

/**
 * Handles saving Minimum Wage configuration data.
 */
export function useMinimumWageMutation(companyId: string) {
  const queryClient = useQueryClient();
  const { t } = useLocalize();

  return useMutation({
    mutationFn: async (payload: MinimumWageConfigurationModel) => {
      const { data } = await axiosInstance.post<MinimumWageConfigurationModel>(
        `/api/${companyId}/configuration/saveMinimumWageConfiguration`,
        {
          configuration: payload,
        }
      );
      return data;
    },

    onError: (error) => {
      console.error('Error saving saveMinimumWageConfiguration settings:', error);
      toast.error({
        title: t('configuration.save-error').toString(),
        text: serverMessage(error),
        autoCloseMs: 8000,
      })
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['configuration.minimumWage', companyId],
      });
      toast.success({
        title: t('configuration.save-changes-title').toString(),
        text: t('configuration.save-changes-details').toString(),
      })
    },
  });
}
